var app = angular.module('leonardo');

var IsManagedBy = function(AccountUserService) {
  return {
    restrict: 'A',
    scope: {
      object: '='
    },
    link: function(scope, element, attrs) {
      if (scope.object) {
        var account_id = (scope.object.account && scope.object.account.id) ? scope.object.account.id : scope.object.account;
        var managed_by = (scope.object.managed_by && scope.object.managed_by.id) ? scope.object.managed_by.id : scope.object.managed_by;
        if (((account_id == AccountUserService.currentAccountUser.account) && (!managed_by))
          || (managed_by == AccountUserService.currentAccountUser.account))
          return;
        else {
          element.addClass('managed-by');
        }
      }
    }
  }
};

app.directive('isManagedBy', ['AccountUserService', IsManagedBy]);